import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiChopin, API_CHOPIN } from '../config/index';
import { Observable } from 'rxjs';
import { EventItem, Pagination, EventsRequestParams, Person } from '@shared/interfaces';

@Injectable()
export class EventsService {
  constructor(
    @Inject(API_CHOPIN) private api: ApiChopin,
    private http: HttpClient
  ) {}

  getAll(params?: EventsRequestParams): Observable<Pagination<EventItem>>{
    return this.http.get<Pagination<EventItem>>(this.api.EVENTS(), { params: params as any });
  }

  get(id: number): Observable<EventItem>{
    return this.http.get<EventItem>(this.api.EVENTS(id));
  }

}
